import { useState, useEffect, useRef } from 'react';
import { useCommunity } from 'contexts/community';
import { useScreen } from 'Screen/ScreenContext';
import api from '@helpers/api';

export function useUserLogs(userId) {
    const { communities, loading: communityLoading } = useCommunity();
    const { setSnackbar } = useScreen();
    const popperRef = useRef();

    const adminCommunities = communities?.filter((c) => c.isAdmin()) ?? [];

    const [selectedCommunity, setSelectedCommunity] = useState(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ pages: 0, records: 0, page: 1 });

    useEffect(() => {
        if (!communityLoading && adminCommunities.length > 0 && !selectedCommunity) {
            setSelectedCommunity(adminCommunities[0]);
        }
    }, [communityLoading, adminCommunities.length]);

    useEffect(() => {
        if (selectedCommunity && userId) {
            fetchLogs(1);
        }
    }, [selectedCommunity?.id, userId]);

    async function fetchLogs(page = 1) {
        if (!selectedCommunity || !userId) return;
        try {
            setLoading(true);
            const { data } = await api.get(
                `community/${selectedCommunity.id}/logs/list?filters[user_id]=${userId}&orderby[id]=desc&page=${page}&per_page=50`
            );
            setLogs(data.data ?? []);
            setPagination({
                pages: data.pages ?? 0,
                records: data.records ?? 0,
                page: data.page ?? 1,
            });
        } catch (e) {
            console.error(e);
            setLogs([]);
            setPagination({ pages: 0, records: 0, page: 1 });
        } finally {
            setLoading(false);
        }
    }

    function handleSelectCommunity(community) {
        setSelectedCommunity(community);
    }

    async function exportLogs() {
        if (!selectedCommunity || !userId) return;
        const { data } = await api.post(
            `community/${selectedCommunity.id}/logs/export?filters[user_id]=${userId}&orderby[id]=desc`
        );
        setSnackbar(
            `A exportação está em andamento, e um email será enviado para "${data.email}" com o arquivo para download`
        );
    }

    return {
        adminCommunities,
        selectedCommunity,
        logs,
        loading,
        pagination,
        fetchLogs,
        exportLogs,
        popperRef,
        handleSelectCommunity,
    };
}
